import { isMarketSol } from '@packages/locale/utils/market.ts'

export const isSolWebsite: () => boolean = () => {
  const { market } = useRuntimeConfig().public
  return isMarketSol(market)
}
